import { getPageText } from '../../../common/utils/FileUtils'
import { errorLog } from '../../../common/logger/Logger'
import { restApiKey } from '../../../_constants/Code'
import { PathInfoList } from '../../../_constants/PathInfoList'
import { httpGet } from '../../../services/api/AmplifyApi'

/** マトリクス画面向け API 呼び出しの薄いラッパー。 失敗時はここでログを残したうえで例外を再送出し、画面の init が「空配列で続行」「エラー文言を出す」など方針を決められるようにする。 */

/**
 * Setting.json を取得（S3 public/text/setting.json）。初期表示1回のみ想定。
 *
 * @returns {Promise<import('./types').SettingJson>}
 */
export async function fetchSettingJson() {
  try {
    const pageText = await getPageText()
    return pageText ?? {}
  } catch (err) {
    errorLog('E000001', 'dashboardItemMatrix', 'fetchSettingJson', err)
    throw err
  }
}

/**
 * 全CHROFY項目一括取得（IF02090）。GET /{corporationNumber}/get_all_chrofy_columns
 *
 * @param {string} corporationNumber
 * @returns {Promise<import('./types').ChrofyColumnsResponse>}
 */
export async function fetchAllChrofyColumns(corporationNumber) {
  try {
    const init = { headers: {} }
    const res = await httpGet(
      restApiKey.CHROFY_REST_API,
      PathInfoList.Resource.getAllChrofyColumns(corporationNumber),
      init
    )
    return Array.isArray(res) ? res : []
  } catch (err) {
    errorLog('E000001', 'dashboardItemMatrix', 'fetchAllChrofyColumns', err)
    throw err
  }
}

/**
 * データ作成タスク一覧取得（IF02028）。GET /{corporationNumber}/datacreatetask_get?searchKey=...
 *
 * @param {string} corporationNumber
 * @returns {Promise<import('./types').DataCreateTaskResponse>}
 */
export async function fetchDataCreateTaskList(corporationNumber) {
  try {
    const init = {
      headers: {},
      queryStringParameters: { searchKey: corporationNumber }
    }
    const res = await httpGet(
      restApiKey.CHROFY_REST_API,
      PathInfoList.Resource.getDataCreateTask(corporationNumber),
      init
    )
    return Array.isArray(res) ? res : []
  } catch (err) {
    errorLog('E000001', 'dashboardItemMatrix', 'fetchDataCreateTaskList', err)
    throw err
  }
}

/**
 * マッピング情報一覧取得（IF02091）。GET /{corporationNumber}/get_generic_mapping_list?data_create_task_key=... 404 の場合は throw
 * する。呼び出し元で 404 を空配列に変換する処理を行う。
 *
 * @param {string} corporationNumber
 * @param {number} dataCreateTaskKey
 * @returns {Promise<import('./types').GenericMappingListResponse>}
 * @throws {Error} 404 を含むすべてのエラーを throw
 */
export async function fetchGenericMappingList(corporationNumber, dataCreateTaskKey) {
  try {
    const init = {
      headers: {},
      queryStringParameters: { data_create_task_key: String(dataCreateTaskKey) }
    }
    const res = await httpGet(
      restApiKey.CHROFY_REST_API,
      PathInfoList.Resource.getGenericMappingList(corporationNumber),
      init
    )
    return Array.isArray(res) ? res : []
  } catch (err) {
    errorLog('E000001', 'dashboardItemMatrix', 'fetchGenericMappingList', err)
    throw err
  }
}
